import { Tag, type TagColour } from '../../components/idsk';
import { useEnumLabel } from '../../api/enums';
import type { InspectionStatus } from '../../api/inspections';

const COLOURS: Record<InspectionStatus, TagColour> = {
  PROPOSAL: 'grey',
  PLANNING: 'blue',
  EXECUTION: 'turquoise',
  EVALUATION: 'purple',
  FINISHED: 'green',
};

/** Status as an ID-SK tag: the text always carries the status (never colour alone). */
export function StatusTag({ status }: { status: InspectionStatus }) {
  const label = useEnumLabel();
  return <Tag colour={COLOURS[status]}>{label('inspectionStatuses', status)}</Tag>;
}
